import { datadogRum } from '@datadog/browser-rum'
import packageJson from '../../package.json'
import { env } from '../env'

const getAllowedTracingUrls = (): Array<string | RegExp> => {
  return [
    /https:\/\/.*\.ottinsights\.sky/,
    /https:\/\/.*\.aieng\.sky/,
    /https:\/\/.*\.gspcloud\.com/,
  ]
}

export const initDatadog = (): void => {
  const isEnabled = env.VITE_DATADOG_ENABLED === 'true'
  if (!isEnabled) {
    console.log('[Datadog] RUM is disabled')
    return
  }

  const applicationId = env.VITE_DATADOG_APPLICATION_ID
  const clientToken = env.VITE_DATADOG_CLIENT_TOKEN

  if (!applicationId || !clientToken) {
    console.warn(
      '[Datadog] Missing APPLICATION_ID or CLIENT_TOKEN. RUM will not be initialized.',
    )
    return
  }

  datadogRum.init({
    applicationId,
    clientToken,
    site: env.VITE_DATADOG_SITE || 'datadoghq.com',
    service: env.VITE_DATADOG_SERVICE_NAME || 'aa-hubble',
    env: env.VITE_DATADOG_ENV || 'local',
    version: packageJson.version,
    sessionSampleRate: Number(env.VITE_DATADOG_SESSION_SAMPLE_RATE) || 100,
    sessionReplaySampleRate:
      Number(env.VITE_DATADOG_SESSION_REPLAY_SAMPLE_RATE) || 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: getAllowedTracingUrls(),
  })

  console.log(
    `[Datadog] RUM initialized for service: ${env.VITE_DATADOG_SERVICE_NAME || 'aa-hubble'}, env: ${env.VITE_DATADOG_ENV || 'local'}`,
  )
}

export const setDatadogUser = (user: {
  id: string
  name?: string
  email?: string
}): void => {
  datadogRum.setUser({
    id: user.id,
    name: user.name,
    email: user.email,
  })
}

export const clearDatadogUser = (): void => {
  datadogRum.clearUser()
}

export const addDatadogContext = (key: string, value: unknown): void => {
  datadogRum.setGlobalContextProperty(key, value)
}

export const trackDatadogAction = (
  name: string,
  context?: Record<string, unknown>,
): void => {
  datadogRum.addAction(name, context)
}

export const trackDatadogError = (
  error: unknown,
  context?: Record<string, unknown>,
): void => {
  datadogRum.addError(error as Error, context)
}
